import orders from './orders.json';
import personalizedFollowUps from './personalizedFollowUps.json';
import sales from './sales.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import botControls from './botControls.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import pipelinesMgmt from './pipelinesMgmt.json';
import commercialTasks from './commercialTasks.json';
import dealSheet from './dealSheet.json';
import lostReasons from './lostReasons.json';
import pipelineStage from './pipelineStage.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import webphone from './webphone.json';
import sla from './sla.json';
import inbox from './inbox.json';
import general from './general.json';
import datePicker from './datePicker.json';
import customRole from './customRole.json';
import revenueAutopilot from './revenueAutopilot.json';
import featureHelp from './featureHelp.json';
import aiMoves from './aiMoves.json';

export default {
  ...orders,
  ...sales,
  ...personalizedFollowUps,
  ...advancedFilters,
  ...agentBots,
  ...botControls,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...pipelinesMgmt,
  ...commercialTasks,
  ...dealSheet,
  ...lostReasons,
  ...pipelineStage,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...inbox,
  ...general,
  ...datePicker,
  ...customRole,
  ...webphone,
  ...revenueAutopilot,
  ...featureHelp,
  ...aiMoves,
};
